import { Popover } from '@storeblocks/popover';

type PopoverContainerProps = {
  id: string | undefined;
  description: string;
};

export const PopoverContainer = ({
  id,
  description
}: PopoverContainerProps) => {
  return (
    <Popover ml="8px" id={`${id}_description`}>
      {description}
    </Popover>
  );
};
